import { StoreInterface } from 'src/store'
import { ELibraryStateInterface } from 'src/store/eLibrary/state'
import { GetterTree } from 'vuex'

const getters: GetterTree<ELibraryStateInterface, StoreInterface> = {
  getTotalStorageUsed: (state: ELibraryStateInterface) => state.totalStorageUsed
}

export default getters
